import { css } from 'styled-components';
import {
  getSpacing, getTypography, SpacingName, TypographyName, BreakpointQueryName, ThemedFunctor,
} from '@doveit/bricks';

export const header: ThemedFunctor = ({ theme }) => css`
  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const title: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.H3)};
  font-weight: normal;
`;

export const search: ThemedFunctor = ({ theme }) => css`
  margin-top: ${theme.spaceUnits.mobile.SMALL};
  display: flex;
  gap: ${theme.spaceUnits.mobile.SMALLER};

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    flex-shrink: 0;
    margin-top: 0;
    gap: ${theme.spaceUnits.desktop.SMALLER};
  }
`;

export const resultsCount: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.BODY)};
  font-style: italic;
  ${getSpacing.paddingTop(theme, SpacingName.SMALLEST)}
`;

export const itemAdv: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.padding(theme, [SpacingName.MEDIUM, SpacingName.SMALL])}
  border-bottom: 1px solid ${theme.palettes.neutrals.light};

  margin: -1px -${theme.spaceUnits.mobile.SMALL} 0;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    margin: -1px 0 0;
  }
`;

export const advWrapper = css`
  max-width: 50rem;
  margin: 0 auto;
`;

export const breadcrumb: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.MEDIUM, 0])}
  border-top: 1px solid ${theme.palettes.neutrals.light};
  margin-top: -1px;
`;

export const serpContents: ThemedFunctor = ({ theme }) => css`
  background-color: ${theme.palettes.neutrals.lighter};
  ${getSpacing.padding(theme, [SpacingName.MEDIUM, 0])}
  position: relative;
  z-index: 1;
`;

export const serpContentBlock: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}

  &:first-child {
    margin-top: 0;
  }
`;

export const serpContentImage: ThemedFunctor = ({ theme, maxWidth }) => css`
  box-shadow: 0 2px 1rem 0 rgba(0, 0, 0, 0.3);
  min-width: 100%;
  width: 100%;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    width: ${maxWidth}px;
  };
`;

export const warningMessage: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
`;
